import React from 'react'

import MuiPagination from '@mui/material/Pagination'

import { PagedResponse } from '../../types/pagedResponse'

interface PaginationProps<T> {
  isLoading: boolean
  paginationSettings: PagedResponse<T>
  onChangePage: (newPageUrl: string) => void
}

const Pagination = <T extends object>(props: PaginationProps<T>) => {
  return props.paginationSettings.final_page_no > 1 ? (
    <MuiPagination
      disabled={props.isLoading}
      count={props.paginationSettings.final_page_no}
      page={props.paginationSettings.current_page_no}
      siblingCount={1}
      boundaryCount={1}
      onChange={(_event, page: number): void => {
        const newPage = props.paginationSettings.page_list.find((x) => x.number === page)
        if (newPage) {
          props.onChangePage(newPage.url)
        }
      }}
    />
  ) : null
}

export default Pagination
